const styles = theme => ({

  droppableTutorial: {
    border: '4px solid #fff',
    borderRadius: '10px',
    backgroundColor: 'transparent',
    width: '400px',
    height: '180px'
  },

  icon: {
    width: '95px',
    height: '45px'
  }
})

export default styles
